import {systemConfirm} from '@web/actions/application'
import {isLocalProfile} from '@web/core/config'
import {createStore as configureStore} from '@web/helpers/redux'
import {browserEventEmitter} from '@web/middlewares/browserEventEmitter'

import {RootState} from '../interfaces'
import createRootReducer from '../slices'

import {authMiddleware, maintenanceHandlerMiddleware, orderInterruptedMiddleware, uiLogTracker} from './middlewares'
import OrderDetailSentryEnhancer from './sentryEnhancer'

export {browserHistory} from '@web/helpers/redux'

export const createStore = (preloadedState?: Partial<RootState>) => {
    return configureStore<RootState>({
        rootReducerCreator: createRootReducer,
        ...(preloadedState ? {...preloadedState} : {}),
        middlewares: [
            authMiddleware,
            maintenanceHandlerMiddleware,
            orderInterruptedMiddleware,
            uiLogTracker,
            browserEventEmitter,
        ],
        defaultMiddlewareOptions: {
            serializableCheck: {
                ignoredActions: [systemConfirm.type],
            },
        },
        sentryEnhancerOptions: OrderDetailSentryEnhancer,
    })
}

const store = createStore()

if (isLocalProfile) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(window as any).store = store
}

export default store

if (isLocalProfile && module.hot) {
    module.hot.accept('../slices', () => store.replaceReducer(createRootReducer()))
}
